import { render, staticRenderFns } from "./introDetail.vue?vue&type=template&id=3be7eca0&scoped=true&"
import script from "./introDetail.vue?vue&type=script&lang=js&"
export * from "./introDetail.vue?vue&type=script&lang=js&"
import style0 from "./introDetail.vue?vue&type=style&index=0&id=3be7eca0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be7eca0",
  null
  
)

export default component.exports